/**
 * 客户列表模块api
 * doc: http://yapi.iklicen.com/project/139/interface/api/cat_6312
 */

import request from './request';

// // 获取注册客户和未注册客户数量
// export function queryCustomerCount(params) {
//     return request('/customer/count', {
//         method: 'POST',
//         params,
//     });
// }

// 获取客户列表
export function queryCustomerList(params) {
    return request('/customer/list', {
        method: 'POST',
        params,
    });
}

// 获取客户详情
export function queryCustomerDetail(personId) {
    return request(`/customer/${personId}`, {
        method: 'GET',
    });
}

// 修改注册客户联系手机号
export function modifyContacts(params) {
    return request('/customer/contacts', {
        method: 'PUT',
        params,
    });
}
// 修改客户姓名
export function modifyName(params) {
    return request('/customer/name', {
        method: 'PUT',
        params,
    });
}

// 编辑客户信息(未注册客户才能编辑)
export function modifyCustomerInfo(params) {
    return request('/customer/', {
        method: 'PUT',
        params,
    });
}

// 查询客户操作记录
export function getHistory(id, params) {
    return request(`/customer/${id}/oplog`, {
        method: 'GET',
        params,
    });
}
